import styled from 'styled-components'

export const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    #safeCheckInformation {
        padding-left: 5px;
    }
`
